// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer___YmyD","title":"card_title__t4SzL","inActive":"card_inActive__1_tlH"};